import { Heading, Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { View } from 'native-base';
import React from 'react';
import { ScrollView } from 'react-native';

import { InvestmentOrders } from './components/InvestmentOrders';
import { OperationsAndMovement } from './components/OperationsAndMovement';

export const Cockpit = () => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
  });

  const isTablet = useBreakpointValue({
    md: true,
    xl: false,
  });

  return (
    <ScrollView>
      <VStack p={Spacing[isMobile ? 'inset.sm' : 'inset.lg']} flex={1}>
        <View width="100%" minW={'container'} flex={1}>
          <VStack space={Spacing['stack.xs']}>
            <VStack space={Spacing['stack.nano']}>
              {isMobile ? (
                <Text variant="semibold" fontSize={Typography['fontsize.lg']}>
                  Cockpit
                </Text>
              ) : (
                <Heading testId="cockpit-title" size="h2">
                  Cockpit
                </Heading>
              )}
              {!isMobile && (
                <Text fontSize={Typography['fontsize.lg']} variant="light">
                  Simplifique o envio e gerenciamento de suas boletas com poucos cliques e tenha o
                  controle total do seu processo.
                </Text>
              )}
            </VStack>
            <InvestmentOrders isMobile={isMobile} isTablet={isTablet} />
            <OperationsAndMovement isMobile={isMobile} isTablet={isTablet} />
          </VStack>
        </View>
      </VStack>
    </ScrollView>
  );
};
